import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import "../profile/booking.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { websiteDetail } from "../../utils/common.data";
import { useBoardingDropping } from "../../context/BoardingDroppingContext";
import {
  adjustToStartOfDayIfGreater,
  handleRedirectUrl,
} from "../../utils/Functions";
// import BookingPageIcon from "../../assets/booking_view.jpg";
import BookingPageIcon from "../../assets/logo.png";
import AndroidBookingPage from "../AndroidBookingPage";
import "./style.css";
// import BookingButton from "../BookingButton";
// import { bookSeatData, CoPassengerSearchData } from "../../utils/data";
import citiesJson from "../../utils/cities";
import PostRequestForm from "../PostRequest";
import { Autocomplete, TextField } from "@mui/material";
import { toast } from "react-toastify";

const AndroidForm = () => {
  const today = dayjs();
  const fTime = today.add(0, "minute");
  const [myDate, setMyDate] = useState(fTime);
  const [err, setErr] = useState(false);
  const [address, setAddress] = useState("");
  const [drop, setDrop] = useState("");
    const [pickupLat, setPickupLat] = useState(null);
    const [pickupLng, setPickupLng] = useState(null);
    const [dropLat, setDropLat] = useState(null);
    const [dropLng, setDropLng] = useState(null);
  const [bookingView, setBookingView] = useState(0);
  const [searchDetail, setSearchDetail] = useState({});

  const { boardingDroppingPoints, fetchBoardingDroppingPoints,categoryTags,fetchCategoryTagsList } =
    useBoardingDropping();

  useEffect(() => {
    if (!boardingDroppingPoints) {
      fetchBoardingDroppingPoints(); // Fetch data if not already available
    }
  }, [boardingDroppingPoints, fetchBoardingDroppingPoints]);
  
    useEffect(() => {
      if (!categoryTags) {
        fetchCategoryTagsList(); // Fetch data if not already available
      }
    }, [categoryTags, fetchCategoryTagsList]);

  useEffect(() => {
    fetchBoardingDroppingPoints();
    fetchCategoryTagsList();
  }, []);

  const location = useLocation();

  useEffect(() => {
    const mainValue = new URLSearchParams(location.search);
    const value = mainValue.get("params");
    //console.log({value})
    if (value) {
      try {
        const testdata = JSON.parse(value);
        // console.log({testdata})
        sessionStorage.setItem("key", testdata?.key);
        sessionStorage.setItem("code", testdata?.c_code);
        sessionStorage.setItem(
          "phone",
          "+" + testdata?.c_code + "" + testdata?.phone
        );
        sessionStorage.setItem("userid", testdata?.userid);
        sessionStorage.setItem("company_id", testdata?.comp_id);
        sessionStorage.setItem("fname", testdata?.fname);
        sessionStorage.setItem("lname", testdata?.lname);
        sessionStorage.setItem("email", testdata?.email);
        sessionStorage.setItem("name", testdata?.name);
        sessionStorage.setItem("city_id", testdata?.city_id);
        sessionStorage.setItem("city_cur", testdata?.city_cur);
        sessionStorage.setItem("auth", JSON.stringify(testdata));
      } catch (error) {
        console.log(`User Params Data`, error?.message);
        handleRedirectUrl(process.env.REACT_APP_TRIP_FAIL_API, "_self");
      }
    } else {
      handleRedirectUrl(process.env.REACT_APP_TRIP_FAIL_API, "_self");
    }
  }, []);
  
    useEffect(() => {
      const isError = sessionStorage.getItem("isError");
      const isMessage = sessionStorage.getItem("isMessage");
      if (isError && isMessage) {
        if (isError == "true" || isError == true) {
          toast.error(isMessage);
        }
        sessionStorage.setItem("isError", false);
        sessionStorage.setItem("isMessage", "");
      }
    }, []);

  const handleDateAndTime = (newTime) => {
    if (newTime) {
      const startOfDay = newTime.isSame(dayjs(), "day")
        ? dayjs() // current day, use selected time
        : newTime.$d; // other date, set to start of day

      setMyDate(startOfDay);
    }
  };

  const onChangeAddress = (e) => {
      const data = citiesJson.find((city) => city.name === e.target.value);
      setAddress(e.target.value);
      setPickupLat(data?.lat || null);
      setPickupLng(data?.lng || null);
  };

  const onChangeDrop = (e) => {
      const data = citiesJson.find((city) => city.name === e.target.value);
      setDrop(e.target.value);
      setDropLat(data?.lat || null);
      setDropLng(data?.lng || null);
  };

  const Validation = () => {
    let result = true;

    if (
      address?.length == 0 ||
      drop?.length == 0 ||
      address == null ||
      drop == null ||
      address == undefined ||
      drop == undefined ||
      dayjs(myDate).isBefore(dayjs(), "day")
    ) {
      result = false;
      setErr(true);
    }
    return result;
  };

  const detailHandler = (e) => {
    e.preventDefault();
    const startOfDay = dayjs(myDate).isSame(dayjs(), "day")
      ? dayjs() // current day, use selected time
      : myDate;
    if (Validation()) {
      const searchDetail = {
        boarding: address,
        dropping: drop,
        date: adjustToStartOfDayIfGreater(startOfDay),
        pickupLat: pickupLat,
        pickupLng: pickupLng, 
        dropLat: dropLat,
        dropLng: dropLng,
      };
      setSearchDetail(searchDetail);
      setBookingView(2);
      sessionStorage.setItem("bookingdetails", JSON.stringify(searchDetail));
    }
  };

  const handleBookingView = (val) => {
    if (val == 1 && Object.keys(searchDetail).length > 0) {
      setAddress(searchDetail?.boarding);
      setDrop(searchDetail?.dropping);
    }
    setMyDate(dayjs(new Date(searchDetail?.date || new Date())));
    setBookingView(val);
  };

  const handleSortCity = (value) => {
    return value.sort((a, b) => a.name.localeCompare(b.name));
  };
  const uniqueCities = useMemo(() => {
    const seen = new Set();
    return handleSortCity(citiesJson).filter((city) => {
      if (seen.has(city.name)) return false;
      seen.add(city.name);
      return true;
    });
  }, [citiesJson]);

  return (
    <>
      {(bookingView == 1 || bookingView == 0) && (
        <div>
          <section className="tj-booking-frm android_booking_form">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-6 booking_page_main">
                  <img
                    className="booking_page_main_image"
                    src={BookingPageIcon}
                    alt={websiteDetail.title}
                    title={websiteDetail.title}
                  />
                </div>
                {/* {bookingView == 0 && (
                  <div className="col-md-6 col-sm-6 booking_select_form_main">
                    <div className="tab-content">
                      <div className="tab-pane active" id="point">
                        <div className="booking-frm booking_tab_view_selection booking_tab_view_selection_new">
                          <BookingButton
                            title={"Book A Seat"}
                            handleBookingView={() => {
                              handleBookingView(1);
                            }}
                            data={bookSeatData}
                          />
                          <BookingButton
                            title={"Search A Co-Passenger"}
                            handleBookingView={() => {
                              handleBookingView(3);
                            }}
                            data={CoPassengerSearchData}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
                {bookingView == 0 && (
                  <div className="col-md-6 col-sm-6 booking_select_form_main">
                    <div className="tab-content">
                      <div className="tab-pane active" id="point">
                        {/* <div
                          className="booking_tab_view_selection_back"
                          onClick={() => {
                            handleBookingView(0);
                          }}
                        >
                          <i className="fas fa-chevron-left"></i>{" "}
                          <span>Back</span>
                        </div> */}
                        <form
                          onSubmit={detailHandler}
                          className="booking-frm"
                          id="User-Form"
                        >
                          <div className="col-md-12 col-sm-12">
                            <strong
                              style={{
                                marginTop: "10px",
                                marginBottom: "-10px",
                              }}
                            >
                              From
                            </strong>
                            <div className="field-holder border padding-input">
                              <Autocomplete
                                options={uniqueCities}
                                getOptionLabel={(option) => {
                                  return option.name ?? "";
                                }}
                                value={
                                  uniqueCities.find(
                                    (city) => city.name === address
                                  ) || null
                                }
                                onChange={(event, newValue) => {
                                  onChangeAddress({
                                    target: { value: newValue?.name || null },
                                  });
                                }}
                                filterOptions={(options, { inputValue }) =>
                                  options.filter((option) =>
                                    option.name
                                      .toLowerCase()
                                      .includes(inputValue.toLowerCase())
                                  )
                                }
                                renderInput={(params) => (
                                  <TextField
                                    key={params.id}
                                    {...params}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    placeholder="Enter From Location"
                                  />
                                )}
                                isOptionEqualToValue={(option, value) => {
                                  // console.log({option},value)
                                  return option.name === value;
                                }}
                              />
                              {/* <select
                                id="boardingPoints"
                                value={address}
                                onChange={onChangeAddress}
                                className="dropdown_main_select"
                              >
                                <option value="">Select From Location</option>
                                {boardingDroppingPoints?.boarding?.map(
                                  (value) => (
                                    <option key={value} value={value}>
                                      {value}
                                    </option>
                                  )
                                )}
                              </select> */}

                              {err && (address?.length <= 0 || !address) ? (
                                <label
                                  htmlFor="u_email"
                                  id="u_email-error"
                                  className="error form_validation_err"
                                  style={{
                                    color: "#e74c3c",
                                    fontWeight: "500",
                                    fontSize: "15px",
                                  }}
                                >
                                  Select From Location
                                </label>
                              ) : null}
                            </div>
                          </div>

                          <div className="col-md-12 col-sm-12">
                            <strong
                              style={{
                                marginTop: "10px",
                                marginBottom: "-10px",
                              }}
                            >
                              To
                            </strong>
                            <div className="field-holder border">
                              {/* <select
                                id="droppingPoints"
                                value={drop}
                                onChange={onChangeDrop}
                                className="dropdown_main_select"
                              >
                                <option value="">Select To Location</option>
                                {boardingDroppingPoints?.dropping?.map(
                                  (value) => (
                                    <option key={value} value={value}>
                                      {value}
                                    </option>
                                  )
                                )}
                              </select> */}
                              <Autocomplete
                                options={uniqueCities}
                                getOptionLabel={(option) => {
                                  return option.name ?? "";
                                }}
                                value={
                                  uniqueCities.find(
                                    (city) => city.name === drop
                                  ) || null
                                }
                                onChange={(event, newValue) => {
                                  onChangeDrop({
                                    target: { value: newValue?.name || null },
                                  });
                                }}
                                filterOptions={(options, { inputValue }) =>
                                  options.filter((option) =>
                                    option.name
                                      .toLowerCase()
                                      .includes(inputValue.toLowerCase())
                                  )
                                }
                                renderInput={(params) => (
                                  <TextField
                                    key={params.id}
                                    {...params}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    placeholder="Enter To Location"
                                  />
                                )}
                                isOptionEqualToValue={(option, value) => {
                                  // console.log({option},value)
                                  return option.name === value;
                                }}
                              />
                              {err && (drop?.length <= 0 || !drop) && (
                                <label
                                  htmlFor="u_email"
                                  id="u_email-error"
                                  className="error form_validation_err"
                                  style={{
                                    color: "#e74c3c",
                                    fontWeight: "500",
                                    fontSize: "15px",
                                  }}
                                >
                                  Select To Location
                                </label>
                              )}
                            </div>
                          </div>

                          <div className="col-md-12 col-sm-12">
                            <strong
                              style={{
                                marginTop: "10px",
                                marginBottom: "-10px",
                              }}
                            >
                              Date
                            </strong>
                            <div className="field-holder">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                  value={myDate}
                                  className="common_form_date_picker"
                                  disablePast
                                  onChange={(e) => handleDateAndTime(e)}
                                  slotProps={{
                                    textField: {
                                      error: false,
                                      inputProps: {
                                        readOnly: true,
                                        tabIndex: -1,
                                      },
                                    },
                                  }}
                                  format="DD/MM/YYYY"
                                  disableOpenOnEnter={true} // Disables manual opening by clicking the input field
                                />
                              </LocalizationProvider>
                            </div>
                            {err && dayjs(myDate).isBefore(dayjs(), "day") ? (
                              <label
                                htmlFor="u_email"
                                id="u_email-error"
                                className="error form_validation_err"
                                style={{
                                  color: "#e74c3c",
                                  fontWeight: "500",
                                  fontSize: "11px",
                                  marginTop: "-10px",
                                  marginBottom: "8px",
                                }}
                              >
                                Please select a future date
                              </label>
                            ) : null}
                          </div>
                          <div className="col-md-12 col-sm-12">
                            <button className="book-btn common_booking_button common_button_border">
                              Search{" "}
                              <i
                                className="fas fa-arrow-circle-right"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      )}
      {bookingView == 2 && (
        <AndroidBookingPage
          searchDetail={searchDetail}
          handleView={() => {
            handleBookingView(0);
          }}
        />
      )}
      {bookingView == 3 && (
        <PostRequestForm
          handleBack={() => {
            handleBookingView(0);
          }}
        />
      )}
    </>
  );
};

export default AndroidForm;
